import { Link } from '@src/component/link'
import Typography from '@ui/Typography'
import { VStack } from '@ui/layout/Stack'

import CallQualityFeedback from './CallQualityFeedback'
import * as styles from './CallQualityWizardTroubleshootStep.css'
import HeartGraphic from './HeartGraphic'
import type { CallQualityWizardIssueFormIssueType } from './callQualityWizardIssueFormCommon'
import { callQualityWizardIssueFormIssue } from './callQualityWizardIssueFormCommon'
import type { CallQualityWizardStepProps } from './types'

type IssueWithoutOther = Exclude<CallQualityWizardIssueFormIssueType, 'other'>

type CallQualityWizardTroubleshootStepProps = {
  issue: IssueWithoutOther
} & CallQualityWizardStepProps

const issueTroubleshootingURL: Record<IssueWithoutOther, `https://${string}`> = {
  one_way_audio:
    'https://support.openphone.com/hc/en-us/articles/1500009860902-Troubleshooting-one-way-call-audio',
  choppy_audio:
    'https://support.openphone.com/hc/en-us/articles/1500009860922-Troubleshooting-choppy-or-robotic-sounding-call-audio',
  delayed_audio:
    'https://support.openphone.com/hc/en-us/articles/1500009860882-Troubleshooting-delayed-call-audio',
  dropped_calls:
    'https://support.openphone.com/hc/en-us/articles/1500009860822-Troubleshooting-call-dropping-issues#troubleshooting-call-dropping-issues-0-0',
} as const

export default function CallQualityWizardTroubleshootStep({
  children,
  onClose,
  issue,
}: CallQualityWizardTroubleshootStepProps) {
  return (
    <CallQualityFeedback onClose={onClose}>
      <CallQualityFeedback.Content>
        <div className={styles.graphic}>
          <HeartGraphic />
        </div>
        <VStack className={styles.textStack} gap={4} justifyContent="center">
          <Typography color="textPrimary" variant="callout">
            Thank you for your feedback
          </Typography>
          <Typography color="textSecondary" variant="caption1">
            Check out our Help Center for more info
          </Typography>
        </VStack>
        <div className={styles.childrenContainer}>
          {children}
          <Link
            href={issueTroubleshootingURL[issue]}
            className={styles.issueTroubleShootingURL}
            target="_blank"
            onClick={onClose}
          >
            <Typography variant="caption1" fontWeight="semibold">
              Troubleshoot {callQualityWizardIssueFormIssue[issue].toLowerCase()}
            </Typography>
          </Link>
        </div>
      </CallQualityFeedback.Content>
    </CallQualityFeedback>
  )
}
